<h1 mat-dialog-title>Available Templates</h1>

<div mat-dialog-content>
  <mat-form-field style="width: 100%">
    <mat-label>Filter</mat-label>
    <input matInput placeholder="Filter Variables..." [formControl]="filterControl" />
  </mat-form-field>

  @if (isLoadingResults) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div style="overflow-x: auto">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      [matSortActive]="pagingConfig.sort"
      [matSortDirection]="pagingConfig.direction"
      class="mat-elevation-z1">
      <!-- Friendly Name Column -->
      <ng-container matColumnDef="friendlyname">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.friendlyName }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="placeholder">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Placeholder</th>
        <td mat-cell *matCellDef="let element">{{ element.placeHolder }}</td>
      </ng-container>

      <!-- Sample Value Column -->
      <ng-container matColumnDef="sampleValue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sample Value</th>
        <td mat-cell *matCellDef="let element">{{ element.sampleValue }}</td>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
        <td mat-cell *matCellDef="let element">{{ element.source }}</td>
      </ng-container>

      <!-- Max Length Column -->
      <ng-container matColumnDef="maxlength">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Max Length</th>
        <td mat-cell *matCellDef="let element">{{ element.maxLength }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Empty State -->
      @if (!isLoadingResults && dataSource.length === 0) {
        <tr>
          <td colspan="4" class="text-center">No results found.</td>
        </tr>
      }
    </table>
  </div>

  <mat-paginator
    [length]="resultLength"
    [pageSize]="pagingConfig.pageSize"
    [pageIndex]="pagingConfig.page - 1"
    [hidePageSize]="true">
  </mat-paginator>
</div>

<div mat-dialog-actions style="justify-content: end">
  <button mat-button [mat-dialog-close]="null">Close</button>
</div>
